import React from "react";
import PropTypes from "prop-types";

export function Wrapper(props) {
  return (
    <div {...props} className={props.className}>
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * child components inside wrapper
   */
  children: PropTypes.element,
};

Wrapper.defaultProps = {
  className: "",
};
